var $ = global.jQuery = global.$;
var _Slider = require('./_Slider');
var _merge = require('lodash/object/merge');

/**
 * Slider widget that implements Slick slider with some default options
 * @class
 * @extends _Slider
 */
var HeroSlider = _Slider.extend(
  /** @lends ItemSlider.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  onWidgetsReady: function() {
    var self = this;

    var options = {
      dots: true
    };

    this.options = _merge(this.options, options);

    this._super();
  }
});

module.exports = HeroSlider;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/HeroSlider.js
// module id = 297
// module chunks = 0